import { observer, useLocalObservable } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'
import { EmptyState } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { GuidelineStaticStore } from 'widgets/GuidelineAlert'
import { TextingHeader } from 'pages/chatbot/pages/texting/ui/TextingHeader'
import { TextingTable } from 'pages/chatbot/pages/texting/ui/TextingTable'
import {
  ChatbotDetailsProvider,
  ChatbotListContext,
  useChatbotListContext,
} from 'pages/chatbot/context'
import { useListLayoutContext } from 'pages/chatbot/layout/ListLayout/context'
import { ChatbotListStore } from 'pages/chatbot/store/listStore'

const TextingUI = observer(() => {
  const entities = useEntitiesContext()
  const { search, setSearch, isEmpty, listLayoutStore } = useChatbotListContext()

  const guidelineStaticStore = useMemo(
    () => new GuidelineStaticStore('chatbotGuidelineHidden', entities),
    []
  )
  useEffect(() => {
    return () => {
      guidelineStaticStore.dispose()
    }
  }, [])

  if (listLayoutStore.isHideChildContent) {
    return null
  }

  if (isEmpty) {
    return <EmptyState variant='default' text='No texting agents' noIcon />
  }
  return (
    <>
      <TextingHeader search={search} setSearch={setSearch} />
      <TextingTable />
    </>
  )
})

export const Texting = () => {
  const listLayoutStore = useListLayoutContext()
  const entities = useEntitiesContext()
  const chatbotListStore = useLocalObservable(() => new ChatbotListStore(listLayoutStore, entities))
  useEffect(chatbotListStore.init, [])
  return (
    <ChatbotListContext.Provider value={chatbotListStore}>
      <ChatbotDetailsProvider>
        <TextingUI />
      </ChatbotDetailsProvider>
    </ChatbotListContext.Provider>
  )
}
